import React from 'react'

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';

const Experience = () => {
  return (
    <Box sx={{ padding: "20px 0px", marginLeft: '20px' }}>
        <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 18, color: '#797979' }}>
            Experience
        </Typography>

        <Box sx={{ marginTop: 3 }}>
            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 18 }}>
                Junior Application Developer
            </Typography>

            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 14 }}>
                Directories Philippines Corporation
            </Typography>

            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 12, color: '#797979' }}>
                NOV 2022 - PRESENT
            </Typography>
            
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Assigned to handle full stack development for their existing & future web projects.
            </ListItem>
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Manages Yellow Pages PH Website & Content Management System using Ruby on Rails, JavaScript, Bootstrap, JQuery.
            </ListItem>
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Developed APIs & integrated into their official website using Rails & PHP.
            </ListItem>
        </Box>

        <Box sx={{ marginTop: 3 }}>
            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 18 }}>
                Web Development Intern
            </Typography>

            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 14, letterSpacing: '0.17em' }}>
                LAMINA STUDIOS
            </Typography>

            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 12, color: '#797979' }}>
                NOV 2021 - DEC 2021
            </Typography>
            
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Created UI Design for AGHIM Web App (All-in-one Online Platform) using Figma & Adobe Photoshop.
            </ListItem>
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Developed web pages & created components for the client side using Blade.
            </ListItem>
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Worked with REST APIs using Laravel & Postman as a testing tool for HTTP Requests.
            </ListItem>
        </Box>

        <Box sx={{ marginTop: 3 }}>
            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 18 }}>
                Game Development Intern
            </Typography>

            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 14, letterSpacing: '0.17em' }}>
                LAMINA STUDIOS
            </Typography>

            <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 300, fontSize: 12, color: '#797979' }}>
                AUG 2021 - SEP 2021
            </Typography>
            
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Worked on the DLC for Nyctophobia: Devil Unleashed using Unity 3D and C# as the programming language.
            </ListItem>
            <ListItem sx={{ display: 'list-item', fontFamily: 'Merriweather', fontWeight: 400, fontSize: 16 }}>
                Created prototypes for the game mechanics such as puzzles and jump scare events that will be used in the development of Nyctophobia: Bloodline DLC.
            </ListItem>
        </Box>
    </Box>
  )
}

export default Experience